import React from 'react';
import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

const SvgIconCustom = global.__MUI_SvgIcon__ || SvgIcon;

let CheckCircleShadow = props =>
  <SvgIconCustom {...props} color={props.color}>
    <circle cx="12" cy="12" r="12"/>
    <g opacity="0.07" fill="#000"><path d="M24,12.51,19.9,8.42l-9.69,9.69,5.35,5.35A12,12,0,0,0,24,12.51Z"/></g>
    <polygon points="6.6 9.62 4.14 12.07 10.17 18.11 19.86 8.42 17.4 5.96 10.17 13.19 6.6 9.62" fill="#fff"/>
  </SvgIconCustom>;

CheckCircleShadow = pure(CheckCircleShadow);
CheckCircleShadow.muiName = 'SvgIcon';

export default CheckCircleShadow;


// WEBPACK FOOTER //
// ./images/SVG/CheckCircleShadow.jsx